module.exports = __webpack_public_path__ + "img/za.9b10244b.svg";